export default "__VITE_ASSET__CNO3Ae0Hiy8SPQkxUdc2pA__"